import { useSuspenseQuery } from '@tanstack/react-query';
import { getEngageMessageTemplates } from 'api/engage';
import { accountQueryKeys } from 'queries/account-query-keys';

const useEngageMessageTemplates = () => {
    return useSuspenseQuery({
        queryKey: accountQueryKeys.engageMessageTemplates(),
        queryFn: () => getEngageMessageTemplates({ limit: 999 }),
        select: data => data.data,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};

export { useEngageMessageTemplates };
